// extracted by mini-css-extract-plugin
export default {"app-aside-nav__link":"a32567","app-aside-nav__link-icon":"c59116","app-aside-nav__link--active":"b65d50"};